import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
export type ApplicationTabContentFieldsFragment = {
    __typename?: 'AutoApplyDraft';
    applicationDraftId: string;
    iaUid: string;
    state: Types.ReviewBeforeSubmitDraftState;
    lastPreviewId?: string | null | undefined;
    locale: any;
    proctors: string;
    applyableJob: {
        __typename?: 'ReviewBeforeSubmitApplyableJob';
        jobId: string;
        clientJobRef?: string | null | undefined;
    };
};

export const ApplicationTabContentFieldsFragmentDoc = gql`
    fragment ApplicationTabContentFields on AutoApplyDraft {
        applicationDraftId
        iaUid
        state
        lastPreviewId
        locale
        proctors
        applyableJob {
            jobId
            clientJobRef
        }
    }
`;
